import React from 'react';
import dayjs from 'dayjs';
import './index.scss';
import { t } from 'i18next';
import { customRound, moneyFormatter } from 'utli';

function DepositInvoiceDetailContent({ data }) {
  return (
    <>
      <div>
        <h1 className='text-center'>{data?.invoice_number}</h1>
        <div className='d-flex mb-2' style={{ columnGap: '125px' }}>
          <h4>
            {t('address_book.code')}: {data?.address_code}
          </h4>
          <h4>
            {t('waybill_entry.sale_person')}: {data?.sale_person?.name}
          </h4>
        </div>
      </div>
      <div className='mt-4'>
        <div
          className='info-item'
          style={{
            // borderBottom: '1px solid rgb(108 108 138)',
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '50%' }}>
            {t('address_book.sender')} {t('information')}
          </h4>
          <h4>
            {' '}
            {t('address_book.receiver')} {t('information')}
          </h4>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {/* {t('waybill_entry.company')} : */}
            {data?.sender?.company}
          </span>
          <span>
            {' '}
            {/* {t('waybill_entry.company')} : */}
            {data?.receiver?.company}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }} className='mb-1'>
            {/* {t('address_book.sender')} :  */}
            {data?.sender?.name}
          </span>
          <span>
            {/* {t('address_book.receiver')}:  */}
            {data?.receiver?.name}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }} className='mb-1'>
            {/* {t('waybill_entry.phone')} :  */}
            {data?.sender?.phone}
          </span>
          <span>
            {/* {t('waybill_entry.phone')} :  */}
            {data?.receiver?.phone}
          </span>
        </div>

        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {/* {t('waybill_entry.address')} :  */}
            {data?.sender?.address}
          </span>
          <span>
            {/* {t('waybill_entry.address')} :  */}
            {data?.receiver?.address}
          </span>
        </div>
      </div>
      <div className='mt-3'>
        <div
          className='info-item'
          style={{
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '50%' }}>{t('waybill_entry.basic_information')}</h4>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {t('custom_duty_invoice.invoice_number')}: {data?.invoice_number}
          </span>
          <span>
            ID No: {data?.id_no || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            License No: {data?.license_no || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            {t('custom_duty_invoice.invoice_date')}: {data?.invoice_date ? dayjs(data.invoice_date).format('DD/MM/YYYY') : '-'}
          </span>
          <span>
            Waybill Number: {data?.waybill_number || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            Currency: {data?.currency || '-'}
          </span>
          <span>
            To Currency: {data?.toCurrency || '-'}
          </span>
        </div>
        <div className='info-item'>
          <span style={{ width: '50%' }}>
            Exchange Rate: {data?.exchangeRate || '-'}
          </span>
        </div>
      </div>
      <div className='mt-3'>
        <div
          className='info-item'
          style={{
            borderBottom: '1px solid rgb(108 108 138)',
            paddingBottom: 5,
          }}
        >
          <h4 style={{ width: '100%' }}>{t('custom_duty_invoice.item_information')}</h4>
        </div>
        
        {/* Items Table - Using table for better layout */}
        <div style={{ overflowX: 'auto', marginTop: '10px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '8px', textAlign: 'center', border: '1px solid #ddd' }}>SR NO</th>
                <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Commodity</th>
                <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Unit</th>
                <th style={{ padding: '8px', textAlign: 'center', border: '1px solid #ddd' }}>QTY</th>
                <th style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>Import Licence Commodity Value/Unit (MMK)</th>
                <th style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>Tax Amount (Excl Tax)</th>
                <th style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>Document/Service Fee</th>
                <th style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>Total Amount (MMK)</th>
                <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Remark</th>
              </tr>
            </thead>
            <tbody>
              {data?.items && data.items.length > 0 ? (
                data.items.map((item, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '8px', textAlign: 'center', border: '1px solid #ddd' }}>{index + 1}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item?.commodity || '-'}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item?.unit || '-'}</td>
                    <td style={{ padding: '8px', textAlign: 'center', border: '1px solid #ddd' }}>{item?.qty || '-'}</td>
                    <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>
                      {item?.import_licence_commodity_value_unit ? moneyFormatter(item.import_licence_commodity_value_unit) : '-'}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>
                      {item?.tax_amount_excl_tax ? moneyFormatter(item.tax_amount_excl_tax) : '-'}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>
                      {item?.doc_service_fee ? moneyFormatter(item.doc_service_fee) : '-'}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'right', border: '1px solid #ddd' }}>
                      {item?.total_amount ? moneyFormatter(item.total_amount) : '-'}
                    </td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item?.remark || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='9' style={{ padding: '20px', textAlign: 'center', border: '1px solid #ddd' }}>
                    {t('nodata')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Total Summary */}
          <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, color: '#333' }}>Grand Total:</h4>
              <h3 style={{ margin: 0, color: '#007bff' }}>
                {data?.items ? 
                  moneyFormatter(
                    customRound(
                      data.items.reduce((sum, item) => sum + (parseFloat(item.total_amount) || 0), 0).toFixed(2)
                    )
                  ) + ' MMK' 
                  : '0.00 MMK'
                }
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default DepositInvoiceDetailContent;
